var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"color":"transparent","top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({},on),[_vm._v("mdi-information-outline")])]}}])},[_c('v-card',{attrs:{"width":"300"}},[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.definition))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }